module.exports = __webpack_public_path__ + "static/grid-d-07a8e452a31ed51849ee4ec05ec69954.jpg";